/**------------- Loading Outlined constants -------------**/

/*  General  */
export const LOADING_OUTLINED_CLASS_NAME =
	"loading-outlined";

/*  Circle  */
export const LOADING_OUTLINED_CIRCLE_IMAGE_CLASS_NAME =
	"loading-outlined-circle";
export const LOADING_OUTLINED_CIRCLE_IMAGE_ALT =
	"circle-loading-outlined";

/*  Logo  */
export const LOADING_OUTLINED_LOGO_IMAGE_CLASS_NAME =
	"loading-outlined-logo";
export const LOADING_OUTLINED_LOGO_IMAGE_ALT =
	"loading-outlined";

/*  Links  */
export const CIRCLE_LOADING_OUTLINED_IMAGE_LINK =
	"/images/circle-loading-outlined.svg";
export const LOGO_LOADING_OUTLINED_IMAGE_LINK =
	"/images/logo-outline.svg";
